import axios from "axios";
import apiUrlOne from "../../utils.js/Config";

// Helper function to get auth headers with Bearer token
const getAuthHeaders = () => {
    const token = localStorage.getItem('accessToken');
    return {
        'accept': 'application/json',
        ...(token && { 'Authorization': `Bearer ${token}` })
    };
};

/**
 * Fetch list of Become Host applications with pagination, search and status filter
 */
export const getBecomeHosts = async (page = 1, limit = 10, search = '', status = '') => {
    try {
        const params = new URLSearchParams({
            page: page.toString(),
            ...(limit !== undefined && limit !== 10 && { limit: limit.toString() }),
            ...(search && { search }),
            ...(status && { status })
        });

        const response = await axios.get(`${apiUrlOne}/become-hosts?${params}`, {
            headers: getAuthHeaders()
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching become-hosts list:", error);
        throw error;
    }
};

/**
 * Fetch a single Become Host application by ID
 */
export const getBecomeHostById = async (id) => {
    try {
        const response = await axios.get(`${apiUrlOne}/become-hosts/${id}`, {
            headers: getAuthHeaders()
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching become-host details:", error);
        throw error;
    }
};

/**
 * Update status & checklist of a Become Host application
 */
export const updateBecomeHostStatus = async (id, updateData) => {
    try {
        const response = await axios.put(`${apiUrlOne}/become-hosts/${id}`, updateData, {
            headers: {
                ...getAuthHeaders(),
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error updating become-host status:", error);
        throw error;
    }
};

/**
 * Assign a Become Host application to an Admin user for review
 */
export const assignBecomeHost = async (id, assignData) => {
    try {
        const response = await axios.put(`${apiUrlOne}/become-hosts/${id}/assign`, assignData, {
            headers: {
                ...getAuthHeaders(),
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error assigning become-host application:", error);
        throw error;
    }
};

/**
 * Delete a Become Host application
 */
export const deleteBecomeHost = async (id) => {
    try {
        const response = await axios.delete(`${apiUrlOne}/become-hosts/${id}`, {
            headers: getAuthHeaders()
        });
        return response.data;
    } catch (error) {
        console.error("Error deleting become-host record:", error);
        throw error;
    }
};
